import { http } from '../utils/http'
import { Response } from '../types/resp';

export const affiliate = {
	previewTakeAffiliateCredit: async () => {
		return http.get<Response<any>>('/affiliate/previewTakeAffiliateCredit')
	},

	linkAffiliate: async (payload: any) => {
		return http.post<Response<any>>('/affiliate/linkAffiliate', payload)
	},

	getAffiliateChildById: async (payload: any) => {
		return http.post<Response<any>>('/affiliate/getAffiliateChildById', payload)
	},

	reportTarnsection: async (payload: any) => {
		return http.post<Response<any>>('/affiliate/reportTarnsection', payload)
	},

	reportTarnsectionShareInOrder: async (payload: any) => {
		return http.post<Response<any>>('/affiliate/reportTarnsectionShareInOrder', payload)
	}
}
